import { render, staticRenderFns } from "./BranchWarehouseManagement.vue?vue&type=template&id=97a30612&scoped=true"
import script from "./BranchWarehouseManagement.vue?vue&type=script&lang=js"
export * from "./BranchWarehouseManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a30612",
  null
  
)

export default component.exports